import { GameObjects, Scene } from "phaser";
import { GameConstants } from "../../GameConstants";

export class CheckButton extends GameObjects.Container {
    private _checkBox: GameObjects.Graphics;
    private _checkBoxMark: GameObjects.Graphics;
    constructor(scene: Scene, x: number, y: number, lang: string, selected: boolean) {
        super(scene, x, y);

        this._checkBox = new GameObjects.Graphics(scene, {
            lineStyle: { color: 0xcccccc, width: 3 },
            fillStyle: { color: 0 }
        });
        this.add(this._checkBox);
        this._checkBox.strokeRect(0, 0, 25, 25);

        this._checkBoxMark = new GameObjects.Graphics(scene, {
            fillStyle: { color: 0xcccccc }
        });
        this.add(this._checkBoxMark);
        this._checkBoxMark.visible = selected;
        this._checkBoxMark.fillRect(4, 4, 17, 17);

        const labels = {
            [GameConstants.LANG_CA]: "Catalan",
            [GameConstants.LANG_DE]: "German",
            [GameConstants.LANG_EN]: "English",
            [GameConstants.LANG_ES]: "Spanish",
            [GameConstants.LANG_FR]: "French",
            [GameConstants.LANG_IT]: "Italian",
            [GameConstants.LANG_PT]: "Portuguese",
        }

        const label = new GameObjects.Text(scene, 40, -3, labels[lang].toUpperCase(), { fontFamily: "Oswald-Medium", fontSize: "24px", color: "#FFFFFF" });
        this.add(label);

        this.setInteractive({
            useHandCursor: true,
            hitAreaCallback: Phaser.Geom.Rectangle.Contains,
            hitArea: new Phaser.Geom.Rectangle(0, 0, label.x + label.displayWidth, label.y + label.displayHeight)
        });
    }

    select(selected: boolean) {
        this._checkBoxMark.visible = selected;
    }
}